import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SubscriptionRoutingModule } from './subscription-routing.module';
import { SubscriptionListComponent } from './pages/subscription-list/subscription-list.component';
import { SubscriptionConfigComponent } from './pages/subscription-config/subscription-config.component';
import { SharedModule } from 'src/app/modules/shared/shared-module';
import { CustomerSubscriptionProfileComponent } from './pages/customer-subscription-profile/customer-subscription-profile.component';
import { SubscriptionReportComponent } from './pages/subscription-report/subscription-report.component';
import { SubscriptionAddNewCustomerComponent } from './components/subscription-add-new-customer/subscription-add-new-customer.component';
import { Ng2TelInputModule } from 'ng2-tel-input';


@NgModule({
  declarations: [
    SubscriptionListComponent,
    SubscriptionConfigComponent,
    CustomerSubscriptionProfileComponent,
    SubscriptionReportComponent,
    SubscriptionAddNewCustomerComponent
  ],
  imports: [
    CommonModule,
    SubscriptionRoutingModule,
    SharedModule,
    Ng2TelInputModule
  ]
})
export class SubscriptionModule { }
